

export const getUpgradeDowngradeValue = (selectedPackage: any, currentPackage: any) => {
    const yearlySubscriptionType = "YEARLY";
    const upgradeText = "UPGRADE";
    const downgradeText = "DOWNGRADE";
    const targetSubscriptionType = currentPackage?.SubcriptionType?.toUpperCase();

    if (targetSubscriptionType === yearlySubscriptionType) {
        return (selectedPackage?.PackagePriceYearly < currentPackage?.PackagePriceYearly) ? downgradeText.toUpperCase() : upgradeText.toUpperCase();
    }
    else {
        return (selectedPackage?.PackagePrice < currentPackage?.PackagePrice) ? downgradeText.toUpperCase() : upgradeText.toUpperCase();
    }
}
